import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  key: 0,
  class: "title__optional"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h2", { "data-testid": _ctx.dataTestid }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.isOptional)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " - " + _toDisplayString(_ctx.$msg('profile.creation.common.field.title.optional')), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}